import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { DefaultIntlFormatValues } from '@ratehub/base-ui';


function AnniversaryBonusDescription({ anniversaryBonusDescription, anniversaryBonus }) {
    return (
        <Choose>
            <When condition={anniversaryBonusDescription}>
                {anniversaryBonusDescription}
            </When>
            <Otherwise>
                <FormattedMessage
                    id="cc.condensed.anniversary-bonus.value"   // id from original implementation for condensed credit cards
                    defaultMessage="{anniversaryBonusPoints, number} points (a {anniversaryBonusValue, number, CAD0} value){newline}Conditions may apply."
                    values={{
                        ...DefaultIntlFormatValues,
                        anniversaryBonusPoints: anniversaryBonus.points,
                        anniversaryBonusValue: anniversaryBonus.value,
                    }}
                />
            </Otherwise>
        </Choose>
    );
}

AnniversaryBonusDescription.propTypes = {
    anniversaryBonusDescription: PropTypes.string,
    anniversaryBonus: PropTypes.shape({
        points: PropTypes.number,
        value: PropTypes.number,
    }),
};

AnniversaryBonusDescription.defaultProps = {
    anniversaryBonusDescription: undefined,
    anniversaryBonus: undefined,
};

export default AnniversaryBonusDescription;
